export const SET_LOADMORE_FAV = 'SET_LOADMORE_FAV';
export const SET_LOADMORE_POST = 'SET_LOADMORE_POST';

export const setLoadMoreFav = () => {
   return {
      type: SET_LOADMORE_FAV,
   };
};

export const setLoadMorePost = () => {
   return {
      type: SET_LOADMORE_POST,
   };
};
